<div class="list-container">
    <div class="list-content">
        <div class="list-details">
            <h4 class="list-details-title">Add Payment Term</h4>
            <div [formGroup]="paymentTermForm" class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="form-group">
                        <label>Term Name <span class="required">*</span></label>
                        <input class="form-control" formControlName="termName" type="text">
                    </div>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="form-group">
                        <label>Term Value <span class="required">*</span></label>
                        <input class="form-control" formControlName="termValue" type="text">
                    </div>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="form-group">
                        <label>Term Type <span class="required">*</span></label>
                        <select class="form-control" formControlName="termType">
                          <option *ngFor="let type of termTypes" [value]="type.value">
                            {{ type.viewValue }}
                          </option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12 add-button">
                    <button type="button" (click)="addPaymentTerm()" class="btn btn-primary">Add Payment Term</button>
                </div>
            </div>
        </div>
    </div>
</div>